import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { ApiGatewayUrl } from "../appsettings";
import ErrorException from "src/components/ErrorException";
import Rest from "../core/rest";

export const heartbeatCall = createAsyncThunk(
    "heartbeat/heartbeatCall",
    async () => {
        try {
            const response = await Rest.post(ApiGatewayUrl + "/heartbeat");
            return response.data;
        }
        catch (ex) {
            ErrorException(ex.response);
        }
    }
)

export const heartbeatSlice = createSlice({
    name: "heartbeat",
    initialState: {
        open: false,
        /* heartbeat for live view */
        streamStatus: [
            false, false, false, false,
            false, false, false, false,
            false, false, false, false,
            false, false, false, false
        ]
    },
    reducers: {
        openDialog(state, action) {
            return { ...state, open: action.payload }
        },
        //heartbeat for live view
        updateCurrentPlayingStatus: (state, action) => {
            let currentPlayingStatus = [...state.streamStatus];
            currentPlayingStatus[action.payload.id] = action.payload.flag
            return { ...state, streamStatus: currentPlayingStatus }
        },
    }
});
export const heartbeatActions = heartbeatSlice.actions;
export const heartbeatState = (state) => state.heartbeat;
export default heartbeatSlice.reducer;
